import { useState } from "react";
import { motion } from "framer-motion";
import { ExternalLink, ShoppingBag, BookOpen, Shield, Smartphone, Globe, Percent, Star, TrendingUp } from "lucide-react";

const AFFILIATE_CATEGORIES = [
  { id: "all", name: "All Deals", icon: TrendingUp },
  { id: "ecommerce", name: "Shopping", icon: ShoppingBag },
  { id: "education", name: "Books & Education", icon: BookOpen },
  { id: "vpn", name: "VPN & Security", icon: Shield },
  { id: "mobile", name: "Mobile & Recharge", icon: Smartphone },
  { id: "hosting", name: "Web & Hosting", icon: Globe },
];

const AFFILIATE_PRODUCTS = [
  // E-commerce
  {
    id: "daraz",
    category: "ecommerce",
    name: "Daraz Nepal",
    description: "Nepal's #1 online shopping platform. Electronics, fashion, home & more.",
    discount: "Up to 70% OFF",
    logo: "https://upload.wikimedia.org/wikipedia/commons/6/60/Daraz_Logo.png",
    link: "https://www.daraz.com.np/",
    featured: true,
    rating: 4.5,
  },
  {
    id: "sastodeal",
    category: "ecommerce",
    name: "SastoDeal",
    description: "Best deals on electronics, gadgets, and lifestyle products in Nepal.",
    discount: "Extra 10% OFF",
    logo: "https://www.sastodeal.com/media/logo/stores/1/logo_1.png",
    link: "https://www.sastodeal.com/",
    featured: false,
    rating: 4.2,
  },
  {
    id: "thulo",
    category: "ecommerce",
    name: "Thulo.com",
    description: "Shop groceries, electronics, and daily essentials online.",
    discount: "Free Delivery",
    logo: "https://thulo.com/images/thulo-logo.png",
    link: "https://thulo.com/",
    featured: false,
    rating: 4.0,
  },
  
  // Books & Education
  {
    id: "thuprai",
    category: "education",
    name: "Thuprai",
    description: "Nepal's largest online bookstore. Nepali & English books delivered.",
    discount: "15% OFF on Orders",
    logo: "https://www.thuprai.com/assets/img/thuprai-logo.png",
    link: "https://www.thuprai.com/",
    featured: true,
    rating: 4.6,
  },
  {
    id: "ekitab",
    category: "education",
    name: "eKitab",
    description: "Digital Nepali books and publications. Read on any device.",
    discount: "First Book Free",
    logo: "https://ekitab.com/logo.png",
    link: "https://ekitab.com/",
    featured: false,
    rating: 4.3,
  },
  {
    id: "coursera",
    category: "education",
    name: "Coursera",
    description: "Learn from top universities. Politics, Economics & more.",
    discount: "7-Day Free Trial",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/97/Coursera-Logo_600x600.svg",
    link: "https://www.coursera.org/",
    featured: true,
    rating: 4.7,
  },
  
  // VPN & Security
  {
    id: "nordvpn",
    category: "vpn",
    name: "NordVPN",
    description: "Secure your internet. Access global content safely.",
    discount: "68% OFF + 3 Months Free",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/5e/NordVPN-logo.svg",
    link: "https://nordvpn.com/",
    featured: true,
    rating: 4.8,
  },
  {
    id: "expressvpn",
    category: "vpn",
    name: "ExpressVPN",
    description: "Ultra-fast VPN for streaming and privacy.",
    discount: "49% OFF Annual Plan",
    logo: "https://upload.wikimedia.org/wikipedia/commons/0/0b/ExpressVPN_Logo.png",
    link: "https://www.expressvpn.com/",
    featured: false,
    rating: 4.7,
  },
  {
    id: "surfshark",
    category: "vpn",
    name: "Surfshark",
    description: "Unlimited devices. Budget-friendly VPN solution.",
    discount: "81% OFF",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Surfshark-logo.png",
    link: "https://surfshark.com/",
    featured: false,
    rating: 4.5,
  },
  
  // Mobile & Recharge
  {
    id: "esewa",
    category: "mobile",
    name: "eSewa",
    description: "Nepal's first digital wallet. Recharge, pay bills, transfer money.",
    discount: "Cashback Offers",
    logo: "https://upload.wikimedia.org/wikipedia/commons/f/ff/Esewa_logo.png",
    link: "https://esewa.com.np/",
    featured: true,
    rating: 4.4,
  },
  {
    id: "khalti",
    category: "mobile",
    name: "Khalti",
    description: "Digital payments made easy. Recharge, tickets, utilities.",
    discount: "Up to Rs.100 Cashback",
    logo: "https://upload.wikimedia.org/wikipedia/commons/e/e6/Khalti_Digital_Wallet_Logo.png",
    link: "https://khalti.com/",
    featured: true,
    rating: 4.5,
  },
  {
    id: "imepay",
    category: "mobile",
    name: "IME Pay",
    description: "Quick mobile payments and remittance services.",
    discount: "New User Bonus",
    logo: "https://imepay.com.np/assets/images/ime-pay-logo.png",
    link: "https://imepay.com.np/",
    featured: false,
    rating: 4.2,
  },
  
  // Web Hosting
  {
    id: "bluehost",
    category: "hosting",
    name: "Bluehost",
    description: "Best WordPress hosting. Start your political blog today.",
    discount: "63% OFF + Free Domain",
    logo: "https://upload.wikimedia.org/wikipedia/commons/6/69/BlueHost_Logo.png",
    link: "https://www.bluehost.com/",
    featured: true,
    rating: 4.5,
  },
  {
    id: "namecheap",
    category: "hosting",
    name: "Namecheap",
    description: "Affordable domains and hosting for your projects.",
    discount: "Up to 50% OFF Domains",
    logo: "https://upload.wikimedia.org/wikipedia/commons/6/65/Namecheap_Logo.svg",
    link: "https://www.namecheap.com/",
    featured: false,
    rating: 4.4,
  },
  {
    id: "hostinger",
    category: "hosting",
    name: "Hostinger",
    description: "Premium web hosting at budget prices.",
    discount: "80% OFF + Free SSL",
    logo: "https://upload.wikimedia.org/wikipedia/commons/8/82/Hostinger_logo.svg",
    link: "https://www.hostinger.com/",
    featured: false,
    rating: 4.3,
  },
];

const ProductCard = ({ product }) => {
  const handleClick = () => {
    // Track affiliate click with PostHog
    if (window.posthog) {
      window.posthog.capture('affiliate_click', {
        product_name: product.name,
        product_id: product.id,
        category: product.category,
        discount: product.discount,
        featured: product.featured,
        rating: product.rating
      });
    }
    
    // Track with Google Analytics (if configured)
    if (window.gtag) {
      window.gtag('event', 'affiliate_click', {
        event_category: 'Affiliate',
        event_label: product.name,
        value: product.id
      });
    }
  };

  return (
    <motion.a
      href={product.link}
      target="_blank"
      rel="noopener noreferrer sponsored"
      onClick={handleClick}
      whileHover={{ y: -5, scale: 1.02 }}
      className="block bg-white/5 backdrop-blur border border-white/10 rounded-xl p-5 hover:border-marigold/50 transition-all group"
      data-testid={`affiliate-${product.id}`}
    >
    {product.featured && (
      <div className="absolute -top-2 -right-2 bg-marigold text-peace-blue text-xs font-bold px-2 py-1 rounded-full">
        FEATURED
      </div>
    )}
    
    <div className="flex items-start gap-4">
      <div className="w-16 h-16 bg-white rounded-lg p-2 flex items-center justify-center shrink-0">
        <img 
          src={product.logo} 
          alt={product.name}
          className="w-full h-full object-contain"
          onError={(e) => { e.target.src = "https://via.placeholder.com/64?text=" + product.name[0]; }}
        />
      </div>
      
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <h3 className="font-bebas text-lg text-white tracking-wider">{product.name}</h3>
          <div className="flex items-center gap-1 text-marigold text-xs">
            <Star size={12} fill="currentColor" />
            <span>{product.rating}</span>
          </div>
        </div>
        
        <p className="text-sm text-gray-400 line-clamp-2 mb-2">{product.description}</p>
        
        <div className="flex items-center justify-between">
          <span className="text-xs bg-gorkhali-red/20 text-gorkhali-red px-2 py-1 rounded-full font-medium flex items-center gap-1">
            <Percent size={12} />
            {product.discount}
          </span>
          <span className="text-xs text-marigold group-hover:text-white flex items-center gap-1 transition-colors">
            Visit Site <ExternalLink size={12} />
          </span>
        </div>
      </div>
    </div>
    </motion.a>
  );
};

const DealsPage = () => {
  const [activeCategory, setActiveCategory] = useState("all");
  
  const filteredProducts = activeCategory === "all" 
    ? AFFILIATE_PRODUCTS 
    : AFFILIATE_PRODUCTS.filter(p => p.category === activeCategory);

  const featuredProducts = AFFILIATE_PRODUCTS.filter(p => p.featured).slice(0, 3);

  return (
    <div className="min-h-screen bg-gradient-to-b from-peace-blue to-[#001529]">
      {/* Hero */}
      <section className="relative py-12 sm:py-16 px-4 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-72 h-72 bg-marigold/10 rounded-full blur-3xl animate-pulse" />
          <div className="absolute bottom-10 right-10 w-72 h-72 bg-gorkhali-red/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: "1s" }} />
        </div>

        <div className="max-w-5xl mx-auto text-center relative z-10">
          <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}>
            <div className="inline-flex items-center gap-2 bg-marigold/20 text-marigold px-4 py-2 rounded-full text-sm font-medium mb-6">
              <TrendingUp size={16} />
              Exclusive Deals for Our Users
            </div>
            
            <h1 className="font-bebas text-4xl sm:text-5xl text-white tracking-wider mb-4" style={{ textShadow: "0 0 40px rgba(247,127,0,0.3)" }}>
              RECOMMENDED DEALS
            </h1>
            
            <p className="text-gray-400 max-w-2xl mx-auto text-sm sm:text-base">
              Handpicked deals from trusted partners. Shop, learn, and save with exclusive discounts.
              <span className="block text-xs text-gray-500 mt-2">* We may earn a commission from purchases made through these links</span>
            </p>
          </motion.div>
        </div>
      </section>

      {/* Featured Section */}
      <section className="px-4 pb-8">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-bebas text-2xl text-white tracking-wider mb-4 flex items-center gap-2">
            <Star className="text-marigold" size={24} />
            TOP PICKS
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {featuredProducts.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="px-4 pb-16">
        <div className="max-w-6xl mx-auto">
          {/* Category Tabs */}
          <div className="flex flex-wrap gap-2 mb-8 justify-center">
            {AFFILIATE_CATEGORIES.map(cat => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  activeCategory === cat.id
                    ? "bg-marigold text-peace-blue"
                    : "bg-white/10 text-gray-300 hover:bg-white/20"
                }`}
              >
                <cat.icon size={16} />
                {cat.name}
              </button>
            ))}
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredProducts.map((product, idx) => (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.05 }}
                className="relative"
              >
                <ProductCard product={product} />
              </motion.div>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-400">No deals found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="px-4 pb-16">
        <div className="max-w-4xl mx-auto bg-gradient-to-r from-gorkhali-red/20 to-marigold/20 border border-white/10 rounded-2xl p-8 text-center">
          <h3 className="font-bebas text-2xl text-white tracking-wider mb-2">WANT YOUR PRODUCT HERE?</h3>
          <p className="text-gray-400 text-sm mb-4">Partner with Nepali Ballot to reach thousands of engaged users.</p>
          <a
            href="mailto:advertise@nepalballot.com"
            className="inline-flex items-center gap-2 bg-marigold hover:bg-marigold/80 text-peace-blue px-6 py-3 rounded-full font-bebas tracking-wider transition-colors"
          >
            Contact Us <ExternalLink size={16} />
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-peace-blue/50 py-6 text-center">
        <p className="text-xs text-gray-500">
          Affiliate Disclosure: We may earn commissions from qualifying purchases.
        </p>
      </footer>
    </div>
  );
};

export default DealsPage;
